import React from "react";
import { toCurrency } from "../tools/currency";
import { toDate,toTime,ToShortDateTime } from "../tools/datetime";
import {fullServerAddress} from "../tools/config"



export const gridOrderStatus = (props) => {
    let xy = StatusBg[props.Status];
    
    return (<span
        style={{ background: xy.StatusBg }}
        className="text-white py-1 px-2 capitalize rounded text-md"
    >
        {xy.Status}
    </span>);
};

export const gridOrderType=(props)=>{
    let xy = typeBg[props.OrderType];
    return (<span
        style={{ background: xy.StatusBg }}
        className="text-white py-1 px-2 capitalize rounded text-md"
    >
        {xy.Status}
    </span>);
}


export const gridOrderPaid=(props)=>{
    let xy = PaidBg[props.Payment];
    return (<span
        style={{ background: xy.StatusBg }}
        className="text-white py-1 px-2 capitalize rounded text-md"
    >
        {xy.Status}
    </span>);
}

export const gridOrderDate=(props)=>{    
    //console.log(props.OrderDate)
    return (<span>
        {(props.OrderDate)}
    </span>);
}

export const gridPrice=(props)=>{    
    return (<span>
        {toCurrency(props.total)}
    </span>);
}

export const gridItemPrice=(props)=>{    
    return (<span>
        {toCurrency(props.Price)}
    </span>);
}
export const gridItemTotal=(props)=>{    
    return (<span>
        {toCurrency(props.Price*props.Quantity)}
    </span>);
}



export const ordersData = (fn, iid) => {
    fetch(fullServerAddress + `/api/reportOrders/getOrders/${iid}`, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json'
        }
    })
    .then((res) => res.json())
    .then((data) => {
        //console.log(data)
        let xData = data.data.map((item, index) => {
            return {
                OrderDate: ToShortDateTime(item.OrderDate),
                OrderType: item.OrderType,
                Payment: item.Payment,
                Status: item.Status,
                UserName: item.UserName,
                TableName: item.TableName,
                IID:item.IID,
                WVat:item.WVat,
                NVat:item.NVat,
                vat:item.vat,
                total:item.Total,
                sub:item.sub,
                Cash:item.Cash,
                Card:item.Card,
                ServiceC:item.ServiceC,
                Discount:item.Discount,
                
            };
        });
        let xSesssion = data.sessions;
        //console.log(xData,xSesssion)
        fn(xData,xSesssion);
        })
    .catch(err => {
        //ShowToast('server Error!!')
    });
}

export const StatusBg = {
    0: {
        Status: 'New',
        StatusBg: '#FEC90F',
    },
    1: {
        Status: 'Open',
        StatusBg: '#8BE78B',
    },
    2: {
        Status: 'Done',
        StatusBg: '#FF5C8E',
    },
    3: {
        Status: 'Paid',
        StatusBg: '#03C9D7',
    },
    4: {
        Status: 'Archived',
        StatusBg: '#999999',
    }
};


export const typeBg = {
    0: {
        Status: 'Unknown',
        StatusBg: '#CCCCCC',
    },
    1: {
        Status: 'In-House',
        StatusBg: '#0C2D48',
    },
    256: {
        Status: 'Takeaway',
        StatusBg: '#000C66',
    }
};

export const PaidBg = {
    0: {
        Status: 'UnPaid',
        StatusBg: '#cccccc',
    }, 
    1: {
        Status: 'Cash',
        StatusBg: '#00cc00',
    }, 
    2: {
        Status: 'CreditCard',
        StatusBg: '#122620',
    },
    3:{
        Status: 'Card',
        StatusBg: '#B68D20',
    },
    4:{
        Status: 'Cheque',
        StatusBg: '#8BE78B',
    }
};

export const FixOrders = (pIID,idList, fn)=>{
    fetch(fullServerAddress + '/api/reportOrders/FixOrders', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({pIID,idList})
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data);
         })
       .catch(err => {
          //ShowToast('server Error!!')
        });
}

export const voidOrders = (idList, fn)=>{
    fetch(fullServerAddress + '/api/reportOrders/voidOrder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({idList})
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data);
         })
       .catch(err => {
          //ShowToast('server Error!!')
        });
}


export const addPADOrder = (SessionIID, Price, EntityButtonIID,  PaymentType,fn)=>{
    fetch(fullServerAddress + '/api/reportOrders/newOrder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({SessionIID, Price, EntityButtonIID,  PaymentType})
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data);
         })
       .catch(err => {
          //ShowToast('server Error!!')
        });
}
export const addTips = (SessionIID, Price, PaymentType, fn)=>{
    fetch(fullServerAddress + '/api/reportOrders/addTips', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({SessionIID, Price, PaymentType})
      })
      .then((res) => res.json())
      .then((data) => {
          fn(data);
         })
       .catch(err => {
          //ShowToast('server Error!!')
        });
}

